export const PERSONALIZED_STICKY_FOOTER_EXP_FLAG = 'pen-5361_v1'
